import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { useConnection } from "../../context/ConnectionContext";
import { clearCanvas, drawPitch, drawStrikeZone } from "../../util/CanvasUtil";
import { ConfigurationRenderProps } from "../StrikeZoneRender";

const Canvas = styled.canvas`
  position: absolute;
`;

const StrikeZone: React.FC<ConfigurationRenderProps> = ({ config }) => {
  const { strikeZone, pitch } = useConnection();
  const ref = useRef<HTMLCanvasElement>();

  useEffect(() => {
    if (!!ref?.current) {
      clearCanvas(ref.current);
      drawStrikeZone(ref.current, strikeZone, config);
      if (!!pitch) {
        drawPitch(ref.current, strikeZone, pitch, config);
      }
    }
  }, [ref, config, strikeZone, pitch]);

  return <Canvas width={config.scaling.width} height={config.scaling.height} ref={ref} />;
};

export default StrikeZone;
